module.exports = __webpack_public_path__ + "static/media/telecom4.97bc3d5c.jpg";